import React, { Component } from 'react'
import SearchContainer from '../../context/SearchContainer'
import { Subscribe } from 'unstated'
import { compose } from 'recompose'
import withSizes from 'react-sizes'
import { MAP_SIZES_TO_PROPS } from '../../../constants'
import FeatureSearchInner from './homeSearchBarInner.js'
//This is a props container wrapper. I'd to start using more of these. Makes it really easy.
//If we ever want to over ride the props that this container gives to FeatureSearchInner, then we just need to write some logic in
//this page to do that.
class FeaturedSearch extends Component {
  render() {
    const { isMobile, makes, locationName } = this.props
    return (
      <Subscribe to={[SearchContainer]}>
        {(search) => {
          return (
            <FeatureSearchInner
              makes={makes}
              isMobile={isMobile}
              onClearLocation={search.clearLocation}
              onUpdateLocation={search.updateLocation}
              searchObject={search}
              defaultLocationName={locationName}
            />
          )
        }}
      </Subscribe>
    )
  }
}
export default compose(withSizes(MAP_SIZES_TO_PROPS))(FeaturedSearch)
